import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Label = ({ label, minWidth = '100px', sx }) => {
  const theme = useTheme();

  return (
    <Typography component="span" variant="body2" sx={styleText(theme, minWidth, sx)}>
      {label}
    </Typography>
  );
};

const styleText = (theme, minWidth, sx) => ({
  minWidth: { minWidth },
  mr: 1,
  color: theme.palette.grey[600],
  cursor: 'default',
  UserSelect: 'none !important',
  ...sx
});

Label.propTypes = {
  label: PropTypes.string,
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sx: PropTypes.object
};

export default Label;
